export const POSTS_PER_PAGE = 3
export const INTERVAL = 60 * 1000
